<script lang="ts">
  import {createEventDispatcher} from "svelte";
  import {fly} from "svelte/transition";
  import { ButtonComponent, CheckboxComponent, SelectField } from "ui";

  const dispatch = createEventDispatcher();

  let items: Array<{name: string, value: string}>;
  let value = "";
  let count = 0;

  const onSubmit = (): void => {
    dispatch("selectMany", value);
  };

  export {items, count};
</script>

<div
  class="
    fixed
    bottom-12
    left-0
    w-full
    p-4
    flex
    flex-col
    gap-4
    bg-slate-100
  "
  in:fly
  out:fly
>
  <div class="flex justify-between">
    <div>Ukupan broj izabranih: {count}</div>
    <CheckboxComponent label="Izaberi sve" value={false}/>
  </div>

  <SelectField label="Akcija" {items} bind:value/>

  <div class="flex justify-center">
    <ButtonComponent on:click={onSubmit}>Potvrdi</ButtonComponent>
  </div>
</div>
